import { singleton } from "tsyringe";

import type {
    WindowAdapterStructure,
    WindowScreen,
    WindowLocation,
} from "@/shared/libs/window/interface";

@singleton()
export default class WindowAdapter implements WindowAdapterStructure {
    /**
     * @param {string} url
     * @param {string} target
     * @param {string} features
     * @returns {Window | null}
     */
    public open = (url: string, target?: string, features?: string): Window | null => {
        return window.open(url, target, features);
    };

    /**
     * @description
     */
    public close = (): void => {
        window.close();
    };

    /**
     * @description

     * @param {string} type 
     * @param {EventListener | EventListenerObject} listener 
     * @param {boolean | AddEventListenerOptions} options 
     */
    public addEventListener = (
        type: string,
        listener: EventListener | EventListenerObject,
        options?: boolean | AddEventListenerOptions,
    ): void => {
        window.addEventListener(type, listener, options);
    };

    /**
     * @description

     * @param {string} type 
     * @param {EventListener | EventListenerObject} listener 
     * @param {boolean | EventListenerOptions} options 
     */
    public removeEventListener = (
        type: string,
        listener: EventListener | EventListenerObject,
        options?: boolean | EventListenerOptions,
    ): void => {
        window.removeEventListener(type, listener, options);
    };

    /**
     * @description

     * @param {any} message 
     * @param {string} targetOrigin 
     * @param {Transferable[]} transfer 
     */
    public postMessage = (message: any, targetOrigin?: string, transfer?: Transferable[]): void => {
        window.postMessage(message, targetOrigin || "*", transfer);
    };

    /**
     * @description

     * @returns {WindowScreen} 
     */
    public getScreen = (): WindowScreen => {
        return {
            width: screen.width,
            height: screen.height,
            availWidth: screen.availWidth,
            availHeight: screen.availHeight,
        };
    };

    /**
     * @description
     * @returns {WindowLocation}
     */
    public getLocation = (): WindowLocation => {
        return {
            href: window.location.href,
            origin: window.location.origin,
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash,
            reload: () => window.location.reload(),
            assign: (url: string) => window.location.assign(url),
            replace: (url: string) => window.location.replace(url),
        };
    };

    /**
     * @description
     * =� ��| 
��
     */
    public focus = (): void => {
        window.focus();
    };

    /**
     * @description

     * @param {number} x 
     * @param {number} y
     */
    public scrollTo = (x: number, y: number): void => {
        window.scrollTo(x, y);
    };

    /**
     * @description

     * @param {string} message 
     * @returns {boolean} 
     */
    public confirm = (message?: string): boolean => {
        return window.confirm(message);
    };

    /**
     * @description

     * @param {string} message 
     */
    public alert = (message?: string): void => {
        window.alert(message);
    };
}
